import { useEffect, useState } from "react";
import axios from "axios";
import { ChevronDown, HelpCircle } from "lucide-react";
import { useT } from "../lib/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function FAQ_Component() {
  const { t, lang } = useT();
  const i18nItems = t("faq.items");
  const [dbItems, setDbItems] = useState(null);

  useEffect(() => {
    if (lang !== "fr") return; // EN visitors keep curated i18n bundle
    axios
      .get(`${API}/faq`)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setDbItems(res.data.map((x) => ({ q: x.question, a: x.answer })));
        }
      })
      .catch(() => {});
  }, [lang]);

  const items = dbItems || i18nItems;

  useEffect(() => {
    const id = "faq-jsonld";
    const old = document.getElementById(id);
    if (old) old.remove();
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      inLanguage: lang === "en" ? "en" : "fr",
      mainEntity: items.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      const c = document.getElementById(id);
      if (c) c.remove();
    };
  }, [items, lang]);

  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-sm tracking-[0.25em] uppercase text-[#1B5E20] font-medium mb-4">
            <HelpCircle className="w-4 h-4" />
            {t("faq.eyebrow")}
          </div>
          <h2 className="font-['Outfit'] text-4xl sm:text-5xl font-light tracking-tight text-[#1A2E1C] leading-tight">
            {t("faq.title1")}{" "}
            <span className="text-[#1B5E20] font-medium">{t("faq.title2")}</span>
          </h2>
        </div>

        <div className="space-y-3">
          {items.map((item, i) => (
            <details
              key={item.q}
              data-testid={`faq-item-${i}`}
              className="group bg-white rounded-3xl border border-[#E5EBE5] hover:shadow-md transition-shadow overflow-hidden"
            >
              <summary className="flex items-center justify-between gap-4 p-6 cursor-pointer list-none">
                <h3 className="font-['Outfit'] font-semibold text-[#1A2E1C] text-base sm:text-lg">
                  {item.q}
                </h3>
                <ChevronDown className="w-5 h-5 text-[#1B5E20] flex-shrink-0 transition-transform group-open:rotate-180" />
              </summary>
              <div className="px-6 pb-6 -mt-2 text-[#5C705E] leading-relaxed">
                {item.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
